export const HbrPlayButton=({width,height,fillColour,handleClick})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        onClick={handleClick}
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M7 6v12l10-6z" />
        </svg>
    );
};

export const HbrStopPlayback=({width,height,fillColour,handleClick})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        onClick={handleClick}
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
        <path d="M13 9h2v6h-2zM9 9h2v6H9z" />
      </svg>
    );
};
export const PauseRound=({width,height,fillColour,handleClick})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        onClick={handleClick}
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
        <path d="M13 9h2v6h-2zM9 9h2v6H9z" />
      </svg>
    );
};
export const PlayRound=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
      <path d="M9 17l8-5-8-5z" />
    </svg>
    );
};

export const HbrMoreHorizontal=({width,height,fillColour,handleClick})=>{
    return(
        <svg viewBox="0 0 24 24" 
        onClick={handleClick}
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M8 12a2 2 0 11-4 0 2 2 0 014 0zM14 12a2 2 0 11-4 0 2 2 0 014 0zM18 14a2 2 0 100-4 2 2 0 000 4z"/>
        </svg>
    );
};

export const HbrAvatarProfile=({width,height})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        fill="#eb268f"
        width={width}
        height={height}>
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z" />
        </svg>
    );
};
export const HbrAvatarProfile2=({width,height})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        fill="#00000030"
        width={width}
        height={height}>
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z" />
        </svg>
    );
};

export const HbrCloseIcon=({width,height,fillColour,handleClick})=>{
    return(
        <svg
        onClick={handleClick}
        viewBox="0 0 24 24"
        fill={fillColour}
        height={height}
        width={width}>
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
     </svg>
    );
};

export const HbrCommentIcon=({width,height,fillColour})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2m0 15.2L18.8 16H4V4h16v13.2z" />
      </svg>
    );
};

export const HbrFlagReport=({width,height,fillColour})=>{
    return(
        <svg
        viewBox="0 0 20 20"
        fill={fillColour}
        height={height}
        width={width}>
        <path fill="none" d="M0 0h20v20H0z" />
        <path d="M12 8l-1-1H7V5.85c.29-.18.5-.48.5-.85 0-.55-.45-1-1-1s-1 .45-1 1c0 .37.21.67.5.85V16h1v-3h3l1 1h4V8h-3zm2 5h-2.59l-1-1H7V8h3.59l1 1H14v4z" />
      </svg>
    );
};

export const HbrDownloadVideo=({width,height,fillColour})=>{
    return(
        <svg
        viewBox="0 0 24 24"
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M12 16l4-5h-3V4h-2v7H8z" />
        <path d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z" />
      </svg>
    );
};

export const HbrSectionAdd=({width,height,fillColour})=>{
    return(
        <svg 
        fill={fillColour} 
        viewBox="0 0 15 15"
         height={height} 
         width={width}>
        <path
          stroke="currentColor"
          d="M4 .5H1.5a1 1 0 00-1 1V4M6 .5h3m2 0h2.5a1 1 0 011 1V4M.5 6v3m14-3v3m-14 2v2.5a1 1 0 001 1H4M14.5 11v2.5a1 1 0 01-1 1H11M7.5 4v7M4 7.5h7m-5 7h3"
        />
      </svg>
    );
}

export const HbrPlayButtonRound=({width,height,fillColour,handleClick})=>{
    return(
        <svg 
        fill={fillColour} 
        viewBox="0 0 24 24" 
        onClick={handleClick}
        cursor={"pointer"}
        height={height}
         width={width}>
        <path
          fill={fillColour}
          fillRule="evenodd"
          d="M12 21a9 9 0 100-18 9 9 0 000 18zm0 2c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z"
          clipRule="evenodd"
        />
        <path fill={fillColour} d="M16 12l-6 4.33V7.67L16 12z" />
      </svg>
    );
};

export const HbrBoldIcon =({width,height,fillColour})=>{
    return(
        <svg
        viewBox="0 0 1024 1024"
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z" />
      </svg>
    );
};
export const HbrItalicIcon =({width,height,fillColour})=>{
    return(
        <svg
        viewBox="0 0 1024 1024"
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" />
      </svg>
    );
};
export const HbrStrikeThroughIcon =({width,height,fillColour})=>{
    return(
        <svg
        viewBox="0 0 1024 1024"
        fill={fillColour}
        height={height}
        width={width}>
        <path d="M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 00-8-7.9z" />
      </svg>
    );
};
export const HbrHighlightIcon =({width,height,fillColour})=>{
    return(
        <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M20.707 5.826l-3.535-3.533a.999.999 0 00-1.408-.006L7.096 10.82a1.01 1.01 0 00-.273.488l-1.024 4.437L4 18h2.828l1.142-1.129 3.588-.828c.18-.042.345-.133.477-.262l8.667-8.535a1 1 0 00.005-1.42zm-9.369 7.833l-2.121-2.12 7.243-7.131 2.12 2.12-7.242 7.131zM4 20h16v2H4z" />
    </svg>
    );
};
export const HbrWordDocument =({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 21 21"
      fill={fillColour}
      height={height}
      width={width}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={fillColour}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16.5 15.5v-10a2 2 0 00-2-2h-8a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2zM7.5 8.5h5M7.5 10.5h6M7.5 12.5h3" />
      </g>
    </svg>
    );
};
export const HbrIconFileCopy =({width,height,fillColour, handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M7 6V3a1 1 0 011-1h12a1 1 0 011 1v14a1 1 0 01-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 013 21l.003-14c0-.552.45-1 1.007-1H7zm2 0h8v10h2V4H9v2zm-2 5v2h6v-2H7zm0 4v2h6v-2H7z" />
    </svg>
    );
};
export const HbrAddIcon =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
    </svg>
    );
};
export const HbrBrushIcon =({width,height,fillColour})=>{
    return(
      <svg
      fill="none"
      stroke={fillColour}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height={height}
      width={width}>
      <path d="M18.37 2.63L14 7l-1.59-1.59a2 2 0 00-2.82 0L8 7l9 9 1.59-1.59a2 2 0 000-2.82L17 10l4.37-4.37a2.12 2.12 0 10-3-3z" />
      <path d="M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7M14.5 17.5L4.5 15" />
    </svg>
    );
};
export const HbrCancel =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      cursor="pointer"
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
    );
};
export const HbrSavedIcon =({width,height,fillColour})=>{
    return(
      <svg
      fill={fillColour}
      viewBox="0 0 16 16"
      height={height}
      width={width}>
      <path d="M2 2v13.5a.5.5 0 00.74.439L8 13.069l5.26 2.87A.5.5 0 0014 15.5V2a2 2 0 00-2-2H4a2 2 0 00-2 2z" />
    </svg>
    );
};
export const HbrEditIcon =({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3l1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" />
     </svg>
    );
};
export const HbrImageIcon =({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2zm3-7l2.363 2.363L14 11l5 7H5l3-4z" />
  </svg>
    );
};
export const HbrVideoIcon =({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M4 8H2v12a2 2 0 002 2h12v-2H4z" />
      <path d="M20 2H8a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2zm-9 12V6l7 4z" />
  </svg>
    );
};
export const HbrArrowLeft =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
    </svg>
    );
};
export const Hbrbackarrow =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z" />
    </svg>
    );
};
export const HbrArrowRight =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
    </svg>
    );
};
export const HbrArrowOpenFile =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      fill={fillColour}
      viewBox="0 0 16 16"
      height={height}
      width={width}>
      <path
        fillRule="evenodd"
        d="M8.636 3.5a.5.5 0 00-.5-.5H1.5A1.5 1.5 0 000 4.5v10A1.5 1.5 0 001.5 16h10a1.5 1.5 0 001.5-1.5V7.864a.5.5 0 00-1 0V14.5a.5.5 0 01-.5.5h-10a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5h6.636a.5.5 0 00.5-.5z"
      />
      <path
        fillRule="evenodd"
        d="M16 .5a.5.5 0 00-.5-.5h-5a.5.5 0 000 1h3.793L6.146 9.146a.5.5 0 10.708.708L15 1.707V5.5a.5.5 0 001 0v-5z"
      />
    </svg>
    );
};
export const HbrShareIcon =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      cursor="pointer"
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 006 9c-1.654 0-3 1.346-3 3z" />
  </svg>
    );
};
export const HbrLiveCam =({width,height,fillColour})=>{
    return(
      <svg
      fill={fillColour}
      viewBox="0 0 16 16"
      height={height}
      width={width}
    >
      <path
        fillRule="evenodd"
        d="M0 5a2 2 0 012-2h7.5a2 2 0 011.983 1.738l3.11-1.382A1 1 0 0116 4.269v7.462a1 1 0 01-1.406.913l-3.111-1.382A2 2 0 019.5 13H2a2 2 0 01-2-2V5z"
      />
    </svg>
    );
};
export const HbrgroupIcon =({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 640 512"
      fill={fillColour}
      height={height}
      width={width}
    >
      <path d="M352 128c0 70.7-57.3 128-128 128S96 198.7 96 128 153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8 2.4-.1 4.7-.2 7.1-.2h61.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9 19.7-26.6 31.3-59.5 31.3-95.1 0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z" />
    </svg>
    );
};
export const HbrSendIcon =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      cursor="pointer"
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M1.923 9.37c-.51-.205-.504-.51.034-.689l19.086-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.475.553-.717.07L11 13 1.923 9.37zm4.89-.2l5.636 2.255 3.04 6.082 3.546-12.41L6.812 9.17z" />
    </svg>
    );
};
export const HbrKeypadIcon =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 576 512"
      cursor="pointer"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-32zm112-208h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm112-112h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z" />
    </svg>
    );
};
export const HbrEmoticonIcon =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      cursor="pointer"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M20 12a8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8 8 8 0 008-8m2 0a10 10 0 01-10 10A10 10 0 012 12 10 10 0 0112 2a10 10 0 0110 10M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5 7.7 8 8.5 8s1.5.7 1.5 1.5m7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5 14.7 8 15.5 8s1.5.7 1.5 1.5m-5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81z" />
    </svg>
    );
};
export const HbrLikeEmoji =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      cursor="pointer"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 001.873-1.298l2.757-7.351A1 1 0 0022 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0013 10h7v1.819z" />
    </svg>
    );
};
export const HbrPrayEmoji =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      cursor="pointer"
      fill={fillColour}
      height={height}
      width={width}
    >
      <path d="M11.43 9.67c.04.11.07.21.07.33v5.22c0 .5-.19.98-.53 1.35l-2.79 3.05-3.4-3.4L6 15 8.8 2.86a1.114 1.114 0 012.2.25v4.96a2.08 2.08 0 00-.5-.07c-1.1 0-2 .9-2 2v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.55.45-1 1-1 .19 0 .35.07.5.16.12.07.21.16.3.26.03.04.06.08.08.13.02.04.04.08.05.12M2 19l4 3 1.17-1.27-3.45-3.45L2 19m16-4L15.2 2.86a1.114 1.114 0 00-2.2.25v4.96c.16-.04.33-.07.5-.07 1.1 0 2 .9 2 2v3c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-3c0-.55-.45-1-1-1-.19 0-.35.07-.5.16-.12.07-.21.16-.29.26-.03.04-.07.08-.09.13-.02.04-.04.08-.05.12-.04.11-.07.21-.07.33v5.22c0 .5.19.98.53 1.35l2.79 3.05 3.4-3.4L18 15m2.28 2.28l-3.45 3.45L18 22l4-3-1.72-1.72z" />
    </svg>
    );
};
export const HbrLoveEmoji =({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 1024 1024"
      cursor="pointer"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
    );
};
export const HbrLikeIconFilled =({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 512 512"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2h144c26.5 0 48 21.5 48 48 0 25.3-19.5 46-44.3 47.9 7.7 8.5 12.3 19.8 12.3 32.1 0 23.4-16.8 42.9-38.9 47.1 4.4 7.2 6.9 15.8 6.9 24.9 0 21.3-13.9 39.4-33.1 45.6.7 3.3 1.1 6.8 1.1 10.4 0 26.5-21.5 48-48 48h-73.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z" />
    </svg>
    );
};
export const HbrDropdownIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M7 10l5 5 5-5z" />
    </svg>
    );
};
export const HbrDropdownClickable=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M7 10l5 5 5-5z" />
    </svg>
    );
};
export const HbrDropUpIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M7 14l5-5 5 5z" />
      </svg>
    );
};
export const HbrPauseIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      cursor={"pointer"}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fillColour}>
      <path d="M8 7h3v10H8zm5 0h3v10h-3z" />
      </svg>
    );
};
export const HbrCamLiveOff=({width,height,fillColour})=>{
    return(
      <svg
      fill={fillColour}
      viewBox="0 0 16 16"
      height={height}
      width={width}>
      <path
        fillRule="evenodd"
        d="M10.961 12.365a1.99 1.99 0 00.522-1.103l3.11 1.382A1 1 0 0016 11.731V4.269a1 1 0 00-1.406-.913l-3.111 1.382A2 2 0 009.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 000 5v6a2 2 0 002 2h5.728L.847 3.366zm9.746 11.925l-10-14 .814-.58 10 14-.814.58z"
      />
    </svg>
    );
};
export const HbrCalenderIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}
    >
      <path d="M19 4h-2V3a1 1 0 00-2 0v1H9V3a1 1 0 00-2 0v1H5a3 3 0 00-3 3v12a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H5a1 1 0 01-1-1v-7h16zm0-9H4V7a1 1 0 011-1h2v1a1 1 0 002 0V6h6v1a1 1 0 002 0V6h2a1 1 0 011 1z" />
    </svg>
    );
};
export const HbrInfoIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      cursor="pointer"
      onClick={handleClick}
      fill={fillColour}
      viewBox="0 0 16 16"
      height={height}
      width={width}>
      <path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108 0a8 8 0 000 16z" />
      <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 11-2 0 1 1 0 012 0z" />
    </svg>
    );
};
export const HbrDeleteIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 002 2h8a2 2 0 002-2V7H6v12z" />
    </svg>
    );
};
export const HbrCrossCalendar=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zm10.707-4.707l-1.414 1.414L12 16.414l-2.293 2.293-1.414-1.414L10.586 15l-2.293-2.293 1.414-1.414L12 13.586l2.293-2.293 1.414 1.414L13.414 15l2.293 2.293zM5 7h14v2H5V7z" />
    </svg>
    );
};
export const HbrTvIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M20 6h-5.586l2.293-2.293-1.414-1.414L12 5.586 8.707 2.293 7.293 3.707 9.586 6H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V8c0-1.103-.897-2-2-2zM4 19V8h16l.002 11H4z" />
    </svg>
    );
};
export const HbrReplyIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
    </svg>
    );
};
export const HbrMic=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M12 16c2.206 0 4-1.794 4-4V6c0-2.217-1.785-4.021-3.979-4.021a.933.933 0 00-.209.025A4.006 4.006 0 008 6v6c0 2.206 1.794 4 4 4z" />
      <path d="M11 19.931V22h2v-2.069c3.939-.495 7-3.858 7-7.931h-2c0 3.309-2.691 6-6 6s-6-2.691-6-6H4c0 4.072 3.061 7.436 7 7.931z" />
    </svg>
    );
};
export const HbrStopRecording=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M7 7h10v10H7z" />
    </svg>
    );
};
export const HbrScrollDown=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      cursor={"pointer"}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M12 15.586l-4.293-4.293-1.414 1.414L12 18.414l5.707-5.707-1.414-1.414z" />
      <path d="M17.707 7.707l-1.414-1.414L12 10.586 7.707 6.293 6.293 7.707 12 13.414z" />
    </svg>
    );
};
export const HbrExitIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      onClick={handleClick}
      id="logoutchat"
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z" />
    </svg>
    );
};
export const HbrBulletinIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M24 24H0V0h24v24z" />
      <path d="M20 12 A8 8 0 0 1 12 20 A8 8 0 0 1 4 12 A8 8 0 0 1 20 12 z" />
    </svg>
    );
};
export const HbrMenuIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg 
      onClick={handleClick}
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fillColour}>
      <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z"/>
      </svg>
    );
};
export const HbrForwardIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg 
        onClick={handleClick}
        cursor={"pointer"}
        viewBox="0 0 24 24"
        width={width}
        height={height}
        fill={fillColour}>
        <path d="M14,9V5l7,7-7,7v-4.1c-5,0-8.5,1.6-11,5.1 1,-5 4,-10 11,-11z"/>
      </svg>
    );
};
export const HbrHalfMoonIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z" />
      </svg>
    );
};
export const HbrSunLightIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M11 4V2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm7.36 3.05l1.41-1.42a.996.996 0 10-1.41-1.41l-1.41 1.42a.996.996 0 101.41 1.41zM22 11h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-10 8c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM5.64 7.05L4.22 5.64c-.39-.39-.39-1.03 0-1.41s1.03-.39 1.41 0l1.41 1.41c.39.39.39 1.03 0 1.41s-1.02.39-1.4 0zm11.31 9.9a.996.996 0 000 1.41l1.41 1.41c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm3.64 6.78l1.41-1.41c.39-.39.39-1.03 0-1.41s-1.03-.39-1.41 0l-1.41 1.41a.996.996 0 000 1.41c.38.39 1.02.39 1.41 0zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z" />
      </svg>
    );
};
export const HbrSearchIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      cursor={"pointer"}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M19.023 16.977a35.13 35.13 0 01-1.367-1.384c-.372-.378-.596-.653-.596-.653l-2.8-1.337A6.962 6.962 0 0016 9c0-3.859-3.14-7-7-7S2 5.141 2 9s3.14 7 7 7c1.763 0 3.37-.66 4.603-1.739l1.337 2.8s.275.224.653.596c.387.363.896.854 1.384 1.367l1.358 1.392.604.646 2.121-2.121-.646-.604c-.379-.372-.885-.866-1.391-1.36zM9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" />
    </svg>
    );
};
export const HbrSortIcon=({width,height,fillColour})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z" />
    </svg>
    );
};
export const HbrStarIcon=({width,height,fillColour, handleClick})=>{
    return(
      <svg
      viewBox="0 0 18 18"
      onClick={handleClick}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z" />
      <path fill="none" d="M0 0h18v18H0z" />
    </svg>
    );
};
export const HbrStarIconOutline=({width,height})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height={height}
      width={width}>
      <path d="M6.516 14.323l-1.49 6.452a.998.998 0 001.529 1.057L12 18.202l5.445 3.63a1.001 1.001 0 001.517-1.106l-1.829-6.4 4.536-4.082a1 1 0 00-.59-1.74l-5.701-.454-2.467-5.461a.998.998 0 00-1.822 0L8.622 8.05l-5.701.453a1 1 0 00-.619 1.713l4.214 4.107zm2.853-4.326a.998.998 0 00.832-.586L12 5.43l1.799 3.981a.998.998 0 00.832.586l3.972.315-3.271 2.944c-.284.256-.397.65-.293 1.018l1.253 4.385-3.736-2.491a.995.995 0 00-1.109 0l-3.904 2.603 1.05-4.546a1 1 0 00-.276-.94l-3.038-2.962 4.09-.326z" />
    </svg>
    );
};
export const HbrMoreVert=({width,height,fillColour, handleClick})=>{
    return(
      <svg
      cursor={"pointer"}
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
    );
};
export const HbrNotificationIcon=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      onClick={handleClick}
      viewBox="0 0 24 24"
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M19 13.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.185 4.074 5 6.783 5 10v3.586l-1.707 1.707A.996.996 0 003 16v2a1 1 0 001 1h16a1 1 0 001-1v-2a.996.996 0 00-.293-.707L19 13.586zM19 17H5v-.586l1.707-1.707A.996.996 0 007 14v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v4c0 .266.105.52.293.707L19 16.414V17zm-7 5a2.98 2.98 0 002.818-2H9.182A2.98 2.98 0 0012 22z" />
    </svg>
    );
};
export const HbrSoundOff=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      fill={fillColour}
      height={height}
      width={width}>
      <path d="M7.727 6.313l-4.02-4.02-1.414 1.414 18 18 1.414-1.414-2.02-2.02A9.578 9.578 0 0021.999 12c0-4.091-2.472-7.453-5.999-9v2c2.387 1.386 3.999 4.047 3.999 7a8.13 8.13 0 01-1.671 4.914l-1.286-1.286C17.644 14.536 18 13.19 18 12c0-1.771-.775-3.9-2-5v7.586l-2-2V2.132L7.727 6.313zM4 17h2.697L14 21.868v-3.747L3.102 7.223A1.995 1.995 0 002 9v6c0 1.103.897 2 2 2z" />
    </svg>
    );
};
export const HbrSoundOn=({width,height,fillColour,handleClick})=>{
    return(
      <svg
      viewBox="0 0 24 24"
      onClick={handleClick}
      fill={fillColour}
      height={height}
      width={width}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M18.5 12A4.5 4.5 0 0016 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z" />
    </svg>
    );
};